import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import classNames from 'classnames';
import { IQuizResponseVM } from '@lialo/core/lib/common';

const PREFIX = 'AnswerButton';

const classes = {
  button: `${PREFIX}-button`,
  selected: `${PREFIX}-selected`,
};
const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.button}`]: {
    color: theme.palette.grey[700],
    margin: theme.spacing(1, 0),
    boxShadow: 'none !important',
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    justifyContent: 'flex-start',
  },

  [`&.${classes.selected}`]: {
    color: theme.palette.grey[800],
    border: `1px solid ${theme.palette.secondary.main}`,
    padding: '5px 15px',
  },
})) as typeof Button;

const Label = styled('div')(() => ({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  flexDirection: 'row',
  display: 'flex',

}));

const Prefix = styled('div')(({ theme }) => ({
  whiteSpace: 'nowrap',
  paddingRight: 4,
  fontWeight: theme.typography.fontWeightBold,
}));

interface IProps {
  answer: IQuizResponseVM;
  onSelect?: (answer: IQuizResponseVM) => void;
  disabled: boolean;
}

const AnswerButton = (props: IProps) => {
  const { answer, onSelect, disabled } = props;

  return (
    <StyledButton
      component={'div'}
      variant={answer.selected ? 'contained' : 'outlined'}
      color={'secondary'}
      className={classNames(classes.button, {
        [classes.selected]: answer.selected,
      })}
      onClick={() => onSelect && onSelect(answer)}
      disabled={disabled}
    >
      <Label>
        {answer.prefix && <Prefix>{`${answer.prefix}: `}</Prefix>}
        <div>{answer.value}</div>
      </Label>
    </StyledButton>
  );
};

export default AnswerButton;
